import React from 'react';
import LegalLayout, { COMPANY, H2, P, UL } from './LegalLayout';

const AcceptableUse: React.FC = () => (
  <LegalLayout
    slug="aup"
    title="Acceptable Use Policy"
    description="Rules for acceptable use of 12and22 hosting, VPS, and email services."
  >
    <P>
      This Acceptable Use Policy (&ldquo;AUP&rdquo;) describes activities that are prohibited on the Services
      provided by {COMPANY.legalName} ({COMPANY.brand}). It is part of our Terms of Service. We may
      suspend or terminate Services that violate this AUP.
    </P>

    <H2>Prohibited content and activity</H2>
    <UL>
      <li>Illegal content or activity, or content that infringes intellectual-property rights.</li>
      <li>Malware, phishing, or content designed to harm users or systems.</li>
      <li>Child sexual abuse material (CSAM) — reported to authorities without exception.</li>
      <li>Spam or unsolicited bulk email, and any violation of anti-spam laws (e.g. CAN-SPAM, GDPR).</li>
      <li>Sending email from our network in a way that harms deliverability or IP reputation.</li>
      <li>Hosting open mail relays, open proxies, or open recursive DNS resolvers.</li>
      <li>Distributed denial-of-service (DDoS) participation, port scanning, or unauthorised access
        attempts against any network or system.</li>
      <li>Cryptocurrency mining on shared hosting, or any activity that abuses shared resources.</li>
      <li>Content that is defamatory, harassing, or promotes violence or hate.</li>
    </UL>

    <H2>Resource usage</H2>
    <P>
      Shared hosting resources are provided for normal website use. Activities that place excessive or
      sustained load on shared infrastructure, degrade service for other customers, or exceed the
      resources allotted to your plan may be throttled, suspended, or require an upgrade to a VPS.
    </P>

    <H2>Security responsibilities</H2>
    <UL>
      <li>Keep your applications, plugins, and software patched and secure.</li>
      <li>Do not store or transmit others&apos; data unlawfully.</li>
      <li>Report vulnerabilities or abuse to{' '}
        <a href={`mailto:${COMPANY.supportEmail}`} className="text-primary-navy underline">{COMPANY.supportEmail}</a>.</li>
    </UL>

    <H2>Enforcement</H2>
    <P>
      We investigate suspected violations and may remove content, suspend, or terminate Services, with
      or without notice depending on severity and legal requirements. We cooperate with law enforcement
      where required. Repeated or egregious violations may result in permanent termination without
      refund.
    </P>

    <H2>Reporting abuse</H2>
    <P>
      To report a violation of this AUP, email{' '}
      <a href={`mailto:${COMPANY.supportEmail}`} className="text-primary-navy underline">{COMPANY.supportEmail}</a>{' '}
      with details and evidence.
    </P>
  </LegalLayout>
);

export default AcceptableUse;
